export default __webpack_public_path__ + "static/media/es_head.695d9dde.jpg";